export default function selector(storeState, props) {
    const ad = _.get(storeState, `resources.ads.${props.adId}.attr`, {});
    const campaign = _.get(storeState, `resources.campaigns.${props.campaignId}.attr`, {});
    return {
        campaign,
        ad,
    };
}
